import React from "react";
import { Box } from "@mui/material";
import HeroSection from "../components/Home/HeroSection";
import VisionMission from "../components/Home/VisionMission";
import FeaturedProducts from "../components/Home/FeaturedProducts";
import CTASection from "../components/Layout/CTASection";
import SEO from "../components/Layout/SEO";
import ScrollToTop from "./ScrollToTop";

const HomePage = () => {
  return (
    <Box>
      <SEO
        title="Enterprise Telecom Solutions & Communication Infrastructure"
        description="ProtoDiag Solutions - Leading provider of enterprise-grade telecom solutions including Bulk Messaging Gateway, Voice Communications Platform, and SMS Firewall. Transform your communication infrastructure with our innovative solutions."
        keywords="ProtoDiag Solutions, telecom solutions, bulk messaging gateway, SMS gateway, voice communications, IVR platform, SMS firewall, enterprise communication, Noida India"
        url="https://www.protodiag.com"
      />
      <ScrollToTop />

      <HeroSection />
      <VisionMission />
      <FeaturedProducts />
      <CTASection
        title="Ready to Transform Your Communication Infrastructure?"
        description="Get in touch with our team to discuss how ProtoDiag Solutions can help your business scale and succeed."
        primaryButtonText="Contact Us"
        primaryButtonLink="/contact"
        secondaryButtonText="Explore Solutions"
        secondaryButtonLink="/products"
        variant="primary"
      />
    </Box>
  );
};

export default HomePage;
